/**
 * Event Service
 * Historical events service API: a read-only record of what happened inside a Convercus loyalty program. It serves the stored event history for accounts, memberships and users, for coupons, for news posts and for workflows, filtered by subject, date range, originating user and event type. Every endpoint is a paginated read; the service never writes, edits or replays events.
 *
 * The version of the OpenAPI document: v1.0.37758
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AccountMembershipDto { 
    /**
     * Unique identifier of the membership
     */
    membershipId: string;
    /**
     * User ID
     */
    userId: string;
    /**
     * Partner ID linked to the membership
     */
    partnerId: string;
    /**
     * Role of the member within the program
     */
    memberRole: AccountMembershipDto.MemberRoleEnum;
}
export namespace AccountMembershipDto {
    export type MemberRoleEnum = 'OWNER' | 'COOWNER' | 'COLLECTOR';
    export const MemberRoleEnum = {
        Owner: 'OWNER' as MemberRoleEnum,
        Coowner: 'COOWNER' as MemberRoleEnum,
        Collector: 'COLLECTOR' as MemberRoleEnum
    };
}


